<template>
	<div>
		<v-layout row wrap>
			<v-flex xs12>
				<v-card color="primary" class=" pt-2">
					<v-layout row wrap>
						<v-flex xs6 px-2>
							<v-text-field
								id="id"
								ref="search"
								solo
							></v-text-field>
						</v-flex>
						<v-flex xs6 px-2>
							<v-textarea
								id="id"
								v-model="fixaddress"
								readonly
								solo
							></v-textarea>
						</v-flex>
					</v-layout>
				</v-card>
			</v-flex>
		</v-layout>
		<div class="map" ref="map"></div>
	</div>
</template>

<script>
import gmapsInit from '@/gmaps'
export default {
	data(){
		return {
			fixaddress:'here'
		}
	},
	
	methods:{
		async start(){
			try {
				const google = await gmapsInit();
				var initLatLng = {
					lat: 31.928543,
					lng: 35.929693
				}
				const geocoder = new google.maps.Geocoder();
				var infowindow = new google.maps.InfoWindow;
				const map = new google.maps.Map(this.$refs.map, {
					center: initLatLng,
					zoom: 12
				});
				

				var marker = new google.maps.Marker({
						position: initLatLng,
						map: map
				})
				marker.setOptions({
					draggable: true,
					animation: 'DROP'
				})
				var options = {
					//types: ['geocode'],
					fields: ['geometry'],
					componentRestrictions: {
						country: 'jo'
					}
				};
				console.log(marker.getPosition())
				var autocompvare = new google.maps.places.Autocomplete(document.querySelector('input'), options);
				// var autocompvare = new google.maps.places.SearchBox(document.querySelector('input'), options);
				google.maps.event.addListener(marker, 'dragend', () => {
						console.log(marker)
						var x = marker.getPosition()
						var newPosition = {
								lat: x.lat(),
								lng: x.lng()
						};
						console.log(newPosition)
						var latlng = {
								lat: parseFloat(newPosition.lat),
								lng: parseFloat(newPosition.lng)
						};
						geocoder.geocode({
							'location': latlng
						}, (results, status) => {
								if (status === 'OK') {
										if (results[0]) {
												map.setZoom(16);
												marker.setOptions({
														position: latlng
												})
												infowindow.setContent(results[0].formatted_address);
												console.log(this.fixaddress)
												console.log(results[0].formatted_address);
												console.log(results[0]);
												let gg = results[0].address_components.map(x => x.long_name)
												let aa = gg.join('\n')
												let pp = results[0].plus_code ? results[0].plus_code.global_code : 'No Code'
												let ll = results[0].plus_code ? results[0].plus_code.compound_code : 'No Code'
												this.fixaddress = `${aa}\n`
													+	`Geo: ${latlng.lat}, ${latlng.lng}\n`
													+	`Local Plus Code: https://plus.codes/${ll}\n`
													+	`Plus Code: https://plus.codes/${pp}`
												infowindow.open(map, marker);
										} else {
												window.alert('No results found');
										}
								} else {
										window.alert('Geocoder failed due to: ' + status);
								}
						});
				})
				google.maps.event.addListener(autocompvare, 'place_changed', function (data) {
					//FIRE SEARCH
					console.log(data)
					console.log(autocompvare)
					console.log(autocompvare.getPlace())

					var x = autocompvare.getPlace()
					console.log('------------------------------------');
					console.log(x);
					console.log('------------------------------------');
					console.log(x.geometry.location.lat());
					console.log(x.geometry.location.lng());
					var newPosition = {
							lat: x.geometry.location.lat(),
							lng: x.geometry.location.lng()
					}
					map.setCenter(new google.maps.LatLng(newPosition.lat, newPosition.lng));
					map.setZoom(16)
					marker.setOptions({
							position: newPosition
					})
					infowindow.setContent('Drag to exact location');
				});

			} catch (error) {
				console.error(error);
			}
		}
	},
	created(){
		this.start()
	}
}

</script>

<style scoped>
.map {
  width: 100vw;
  height: 56vh;
}
</style>

